import React, { useState } from "react";
import { IPhotosGalleryProps } from "./PhotosGalleryProps";
import GalleryModal from "../GalleryModal/GalleryModal";
import { Container, FirstRow, SecondRow } from "./PhotosGalleryHelpers";

const PhotosGallery = (props: IPhotosGalleryProps): JSX.Element => {
  const photos = props.photos;
  const color = props.color || "inherit";
  const [isOpen, setIsOpen] = useState(false);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);

  const handleThumbnailClick = (event: any) => {
    const activeIndex = parseInt(event.currentTarget?.dataset?.number) || 0;
    setActivePhotoIndex(activeIndex);
    setIsOpen(true);
  };

  return (
    <Container>
      <FirstRow
        gallery={photos}
        imgCountPerRow={props.imgCountPerRow}
        title={props.title}
        subtitle={props.subtitle}
        color={color}
        onThumbnailClick={handleThumbnailClick}
      />
      <SecondRow
        gallery={photos}
        imgCountPerRow={props.imgCountPerRow}
        onThumbnailClick={handleThumbnailClick}
      />
      <GalleryModal
        show={isOpen}
        photos={props.photos}
        onClose={() => setIsOpen(false)}
        title="Photo Gallery"
        activePhotoIndex={activePhotoIndex}
        newCarousel={props.newCarousel ? true : false}
      />
    </Container>
  );
};

export default PhotosGallery;
